import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const Spin = ({
  height = '50px',
  width = '50px',
}) => {
  return (
    <div
      style={{ width, height }}
      className={classnames('svg', 'svg-spin')}
    >
      <svg className="circular" viewBox="25 25 50 50">
        <circle className="path" cx="50" cy="50" r="20" fill="none" strokeWidth="6" strokeMiterlimit="10" />
      </svg>
    </div>
  );
};

Spin.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
};

export default Spin;
